import {debounceTimeout} from 'constants/DefaultValues';
import {useState, useEffect} from 'react';

export function useDebounceState<T>(
  defaultValue: T | null = null,
  timeout: number = debounceTimeout,
): [T | null, (value: T) => void] {
  const [debouncedValue, setDebouncedValue] = useState<T | null>(
    defaultValue,
  );
  const [value, setValue] = useState<T | null>(null);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, timeout);

    return () => {
      clearTimeout(handler);
    };
  }, [value, timeout]);

  return [debouncedValue, setValue];
}
